// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Clock(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Clock" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.201 22.5 1.5 17.799 1.5 12C1.5 6.20103 6.201 1.5 12 1.5C17.799 1.5 22.5 6.20103 22.5 12ZM13.5 12.7791V6H10.5V14.2209L14.813 17.6713L16.687 15.3287L13.5 12.7791Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Clock.js.map